import { T } from '@/i18n/LocaleProvider';
import Box from '@mui/material/Box';
import { MONO_FONT } from '@/theme';
import Typography from '@mui/material/Typography';

export default function FeatureCard({
  index,
  icon,
  title,
  body,
  dark = false,
  accent = false,
  size = 'md',
  position,
  cols,
}) {
  const label =
    index != null ? String(Number(index) + 1).padStart(2, '0') : null;
  const pad =
    size === 'sm' ? { xs: '20px', md: '24px' } : { xs: '24px', md: '32px' };
  // Con position y cols ({ xs, md }): sin padding ni borde en los bordes exteriores, como la franja del PageHero.
  const edges = position != null &&
    cols && {
      pl: {
        xs: position % cols.xs === 0 ? 0 : pad.xs,
        md: position % cols.md === 0 ? 0 : pad.md,
      },
      pr: {
        xs: position % cols.xs === cols.xs - 1 ? 0 : pad.xs,
        md: position % cols.md === cols.md - 1 ? 0 : pad.md,
      },
      borderRightWidth: {
        xs: position % cols.xs === cols.xs - 1 ? 0 : '1px',
        md: position % cols.md === cols.md - 1 ? 0 : '1px',
      },
    };

  return (
    <Box
      sx={{
        p: pad,
        borderRight: '1px solid',
        borderColor: dark ? 'grey.800' : 'grey.200',
        bgcolor: accent ? 'primary.lightest' : 'transparent',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        '&:last-child': {
          borderRight: 'none',
        },
        ...edges,
      }}
    >
      {(label || icon) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          {label && (
            <Box
              sx={{
                fontFamily: MONO_FONT,
                fontSize: '11px',
                fontWeight: 500,
                letterSpacing: '0.08em',
                color: 'text.accent',
              }}
            >
              <T>Caso </T>
              <T>{label}</T>
            </Box>
          )}
          {icon && (
            <Box
              sx={{
                fontSize: '20px',
                color: 'text.accent',
              }}
            >
              <T>{icon}</T>
            </Box>
          )}
        </Box>
      )}

      <Typography
        variant="h4"
        component="h3"
        sx={{
          fontSize:
            size === 'sm'
              ? 'clamp(15px, 1.1vw, 17px)'
              : 'clamp(17px, 1.3vw, 19px)',
          fontWeight: 500,
          letterSpacing: '-0.01em',
          color: dark ? 'common.white' : 'text.primary',
          lineHeight: 1.3,
        }}
      >
        <T>{title}</T>
      </Typography>

      {body && (
        <Typography
          sx={{
            fontSize: '14px',
            lineHeight: 1.7,
            color: dark ? 'text.muted' : 'grey.600',
          }}
        >
          <T>{body}</T>
        </Typography>
      )}
    </Box>
  );
}
